import { apiClient, unwrap } from './client';

import type { ApiResponse, NotificationList } from '@/types';

export async function getNotifications(limit = 50): Promise<NotificationList> {
  const response = await apiClient.get<ApiResponse<NotificationList>>('/notifications', {
    params: { limit },
  });
  return unwrap(response);
}

export async function markAllRead(): Promise<{ ok: boolean; count: number }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean; count: number }>>(
    '/notifications/read',
  );
  return unwrap(response);
}

export async function markOneRead(id: number): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>(
    `/notifications/${id}/read`,
  );
  return unwrap(response);
}
